import { menuAction } from '../../actions/menuActions';
import { trackingAction } from './student/tracking/itemsTrackingActions';

export type CurrentResourceReducerState = string | null;

export const currentResourceReducer = (
  state: CurrentResourceReducerState = null,
  action: any
): CurrentResourceReducerState => {
  switch (action.type) {
    case menuAction.SideMenu_SelectedResource:
      return action.payload;
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectSequencedFlowItem:
    case menuAction.SideMenu_SelectedQuiz:
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedSubmenuItem:
    case trackingAction.Tracking_ResetProgress:
    case menuAction.SideMenu_DeselectedResource:
      return null;
    default:
      return state;
  }
};
